
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.125 5H13.562A3.875 3.875 0 0010 2.5 3.75 3.75 0 006.5 5H3.875A1.312 1.312 0 002.5 6.25 1.312 1.312 0 003.875 7.5H6.5A3.75 3.75 0 0010 10a3.875 3.875 0 003.563-2.5h12.562A1.312 1.312 0 0027.5 6.25 1.314 1.314 0 0026.125 5zM10 7.5A1.25 1.25 0 1110 5a1.25 1.25 0 010 2.5zM26.125 13.75h-2.563A3.875 3.875 0 0020 11.25a3.75 3.75 0 00-3.5 2.5H3.875a1.25 1.25 0 000 2.5H16.5a3.75 3.75 0 003.5 2.5 3.875 3.875 0 003.563-2.5h2.562a1.25 1.25 0 000-2.5zM20 16.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM26.125 22.5H15.437a3.875 3.875 0 00-3.562-2.5 3.75 3.75 0 00-3.5 2.5h-4.5a1.25 1.25 0 000 2.5h4.5a3.75 3.75 0 003.5 2.5 3.875 3.875 0 003.563-2.5h10.687a1.25 1.25 0 000-2.5zM11.875 25a1.25 1.25 0 110-2.501 1.25 1.25 0 010 2.501z","fill":"currentColor","fill-opacity":".54"}})])
          )
        }
      }
    